class TimeTitleController {
    constructor() {
      this.name = 'time-title';
    }
  }
  
  export default TimeTitleController;
  


// WEBPACK FOOTER //
// ./client/app/components/title-time/time-title.controller.js